export function watchVideo(video) {
  return {
    type: "WATCH_VIDEO",
    payload: video
  }
}

export function closeVideo() {
  return {
    type: "CLOSE_VIDEO"
  }
}